import { render, staticRenderFns } from "./DealChose.vue?vue&type=template&id=25843552&scoped=true&"
import script from "./DealChose.vue?vue&type=script&lang=js&"
export * from "./DealChose.vue?vue&type=script&lang=js&"
import style0 from "./DealChose.vue?vue&type=style&index=0&id=25843552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25843552",
  null
  
)

export default component.exports